<div class="about">
  <div>
    <div>
      <div class="picture-list">
        <mat-grid-list cols="3" rowHeight="5:5">
          <mat-grid-tile *ngFor="let winner of contestWinners">

            <mat-card class="winner-card">
              <mat-card-header>
                <div mat-card-avatar class="winner-header-image"></div>
                <mat-card-title>
                  {{winner.firstName}} {{winner.lastName}} - {{winner.voteChoice}}
                </mat-card-title>
                <mat-card-subtitle>{{ winner.schoolName }} - {{ winner.grade }}</mat-card-subtitle>
              </mat-card-header>
              <img [src]="winner.pictureThumbName" class="img-fluid" alt="" (click)="open(winner)">
            </mat-card>
          </mat-grid-tile>
        </mat-grid-list>
      </div>
    </div>
  </div>
</div>
<ngx-spinner [fullScreen]="true" type="square-jelly-box" size="medium">
  <p class="loading">Loading ...</p>
</ngx-spinner>
